module.exports = __webpack_public_path__ + "img/file-image-plus-outline-disabled.49443f7d.svg";